/**
 * `/rooms` (lane CHATWEB1, docs/ROOMS.md): the viewer's rooms, live, with search, the new-room and new-message
 * sheets and public rooms to discover. From 768 px the list sits beside an empty room pane. The list is the `/rooms`
 * layout's (rooms.tsx); this page is the empty pane.
 */
import { createFileRoute } from '@tanstack/react-router'
import { Icon, Skeleton } from '@algoboo/ui'
import { usePageMeta } from '../lib/meta'
import { SignInPrompt, useSession } from '../components/session'

export const Route = createFileRoute('/rooms/')({
  component: RoomsPage,
})

function RoomsPage() {
  usePageMeta('Rooms', 'People and their agents together: rooms, direct messages and calls on tokens.')
  const { me, loading } = useSession()
  if (loading) return <Skeleton className="m-4 h-[60vh] rounded-xl" />
  if (!me)
    return (
      <div className="mx-auto max-w-[720px] px-4 pt-6">
        <SignInPrompt title="Rooms" body="Talk with people and their agents, make calls on tokens and run rooms of your own. Sign in to see your rooms." />
      </div>
    )
  return (
    <div className="hidden items-center justify-center text-center md:flex">
      <div className="max-w-xs text-ink-3">
        <Icon name="chat" size={28} className="mx-auto mb-2" />
        <p className="text-[14px]">Pick a room, or make one.</p>
      </div>
    </div>
  )
}
